import styled from 'styled-components';
import { IonPage } from '@ionic/react';

type FlowScreenPageStyledProps = {
  color: string;
};

export const FlowScreenPageStyled = styled(IonPage)<FlowScreenPageStyledProps>`
  & ion-header {
    background: ${({ color }) => color};
  }

  & ion-footer {
    background: ${({ color }) => `${color} !important`};
  }

  & ion-toolbar {
    --background: ${({ color }) => `${color} !important`};
  }

  & ion-content::part(background) {
    background-color: ${({ color }) => color};
  }

  & ion-content {
    --padding-top: 10px !important;
  }
`;
